/**
 * Transform Typesense color data to the expected inventory format
 * that matches the previous Firebase function response structure
 */
export const transformTypesenseToInventoryFormat = (colorData, warehouses) => {
  const result = {};

  // Process each size for this color
  colorData.sizes.forEach(sizeData => {
    result[sizeData.sku] = {};

    warehouses.forEach(warehouse => {
      const warehouseCode = warehouse.letterCode;
      const sizeName = sizeData.name;

      // Get current inventory from currentInventory field
      const onHand = colorData.currentInventory?.[warehouseCode]?.[sizeName] || 0;

      // Find incoming inventory for this size/warehouse combination
      const incoming = findIncomingInventory(
        colorData.incomingInventory,
        warehouseCode,
        sizeName
      );

      // Build the inventory data object to match expected format
      result[sizeData.sku][warehouseCode] = {
        onHand,
        size: sizeName,
        ...(incoming && {
          incomingDate: new Date(incoming.date).getTime(),
          quantityToReceive: incoming.quantity
        })
      };
    });
  });

  // Return in the same format as the Firebase function
  return { data: result };
};

/**
 * Find incoming inventory data for a specific warehouse and size
 */
const findIncomingInventory = (incomingInventory, warehouseCode, sizeName) => {
  const warehouseIncoming = incomingInventory?.[warehouseCode];
  if (!warehouseIncoming || !Array.isArray(warehouseIncoming)) {
    return null;
  }

  // Look through all shipments for this warehouse
  for (const shipment of warehouseIncoming) {
    if (shipment.incomingBySize?.[sizeName]) {
      return {
        date: shipment.date,
        quantity: shipment.incomingBySize[sizeName]
      };
    }
  }

  return null;
};

/**
 * Process inventory data and handle any special size logic if needed
 * This replaces the complex outlier size handling from the original implementation
 */
export const processInventoryData = (colorData, warehouses) => {
  // Transform the data
  const inventoryData = transformTypesenseToInventoryFormat(colorData, warehouses);

  // All the inventory data (including special sizes like 2XS, 6XL, TALL LG, TALL XL)
  // should already be included in the currentInventory and incomingInventory fields
  // so no additional processing is needed

  return inventoryData;
};